import { Fatura } from './fatura';

export class FaturalarPage {

    currentPage: number;
    pageCount: number;
    pageSize: number;
    rowCount: number;
    firstRowOnPage: number;
    lastRowOnPage: number;
    private pResults: Fatura[];

    constructor(obj?: any) {
        if (obj == null) {
            return;
        }
        Object.assign(this, obj);
    }

    public get results(): Fatura[] {
        return this.pResults;
    }

    public set results(list: Fatura[]) {
        if (list != null) {
            this.pResults = list.map(t => new Fatura(t));
        }
    }
}
